import e, { useContext as i } from "react";
import { DesktopFlyout as a } from "./DesktopFlyout";
import { PrimaryNavContext as p } from "./PrimaryNavContext";
import { TriggerIcon as m } from "./TriggerIcon";

var v = function v() {
  var _i = i(p),
      t = _i.isDesktopMenuOpen,
      n = _i.setIsDesktopMenuOpen,
      s = _i.setIsUserActionsMenuOpen,
      o = _i.setActiveFlyout,
      r = _i.handleFlyoutClose;

  return e.createElement("li", {
    className: "hg-primarynav__item hg-primarynav__item--menu"
  }, e.createElement("div", {
    className: "hg-primarynav__desktop-item"
  }, e.createElement("button", {
    className: "hg-primarynav__desktop-item-trigger-button",
    id: "menutrigger-desktop-button",
    "aria-controls": "hg-primarynav-desktop-menu",
    "aria-expanded": t,
    "aria-label": "Desktop Menu",
    type: "button",
    onClick: function onClick() {
      t ? (n(!1), o(null), r()) : (s(!1), n(!0), o(null), r());
    }
  }, e.createElement("span", {
    className: "hg-primarynav__desktop-item-trigger-icon"
  }, e.createElement(m, {
    svgPrefix: "desktop"
  }))), e.createElement(a, null)));
};

export { v as DesktopMenuTrigger };